import {
  useCompany,
  useGetCompanyAttributeOptions,
  useGetTaskGroupOptions,
  usePermissions,
  useUpsertTaskTemplate,
  useGetCompanyRoleOptions,
} from '@dispatch/shared/hooks';
import {
  getValuesForSubmit,
  taskTemplateDefaultValues,
  TaskTemplatesDetails,
} from '@dispatch/web/features/task-templates';
import {
  TaskTemplateForm,
  TaskTemplatesPostBody,
} from '@dispatch/shared/types';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useNotificationMutationFactory } from '@dispatch/web/ui';
import { useCurrentUser } from '@dispatch/web/auth';

const CreateTaskTemplate = () => {
  const { permissions } = usePermissions();
  const { tenantId } = useCurrentUser();
  const { company, perilOptions: perils } = useCompany();
  const id = uuidv4();
  let externalId = '';
  const navigate = useNavigate();
  const outletContext: {
    refetchList: () => Promise<void>;
  } = useOutletContext();

  const { companyAttributes } = useGetCompanyAttributeOptions(
    company?.attributeDefinition || []
  );
  const { taskGroupOptions, taskGroupOptionsStatus } = useGetTaskGroupOptions();
  const { companyRoles } = useGetCompanyRoleOptions(company?.role || []);
  const { notifySuccess } = useNotificationMutationFactory(
    'Task Template',
    'create'
  );
  const onSuccess = () => {
    notifySuccess();
    outletContext?.refetchList?.();
    navigate(`/admin/task-templates/${externalId}`);
  };

  const { upsertTaskTemplate } = useUpsertTaskTemplate(onSuccess, tenantId, id);

  const submitData = (values: TaskTemplateForm) => {
    const output: TaskTemplatesPostBody = getValuesForSubmit(values);

    const UUID = id;
    const postBody: TaskTemplatesPostBody & { id: string; tenantId: string } = {
      ...output,
      id: UUID,
      tenantId: tenantId || '',
      createdAt: new Date().toISOString(),
    };

    externalId = output.externalId;
    upsertTaskTemplate(postBody);
  };

  const handleStatuses = () => {
    if (taskGroupOptionsStatus === 'loading') {
      return 'loading';
    }

    return 'success';
  };

  return (
    <TaskTemplatesDetails
      status={handleStatuses()}
      onSubmit={submitData}
      data={taskTemplateDefaultValues}
      attributeDefinitions={companyAttributes}
      taskGroupOptions={taskGroupOptions}
      companyUserRoleOptions={companyRoles || []}
      perilOptions={perils}
      permissions={permissions}
    />
  );
};

export default CreateTaskTemplate;
